/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable node/no-unpublished-import */

export * from '@tensorflow/tfjs-node-gpu';
